export default __webpack_public_path__ + "static/media/polaroid37.73aa00d7.jpg";